  
  <script>
  import Footer from "@/components/layout/FooterScreen.vue";
  import Header from "@/components/layout/HeaderScreen.vue";

  export default {
    components: { Footer, Header },

    computed: {
      currentYear() {
        return new Date().getFullYear();
      },
    },
  };
  </script>
<template>
    <div class="d-flex flex-column min-vh-100">
      <!-- Header -->
      <Header />
        <main class="flex-grow-1">
        <div class="">
          <slot></slot>
        </div>
      </main>
      <Footer />
    </div>
  </template>

  
  <style scoped>

  .shadow-sm {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  </style>